import { Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const getSeverity = (result) => {
  if (result.connected && result.folders.every((folder) => folder.accessible)) {
    return 'success';
  }
  return 'error';
};

const SftpConnectionTestResult = ({ result }) => {
  const { t } = useTranslation();

  if (!result) {
    return null;
  }

  const getTitle = () => {
    if (result.connected) {
      return t('sftpConnections.test.connected');
    }
    return t('sftpConnections.test.connectionFailed');
  };

  const getErrorMessage = () => {
    if (result.connectionError === 'authentication_failed') {
      return t('sftpConnections.test.authenticationFailed');
    }
    if (result.connectionError === 'invalid_configuration') {
      return t('sftpConnections.test.invalidConfiguration');
    }
    return t('sftpConnections.test.serverUnreachable');
  };

  const getFolderLabel = (folder) => {
    if (folder.accessible) {
      return t('sftpConnections.test.accessible');
    }
    return t('sftpConnections.test.inaccessible');
  };

  return (
    <Alert severity={getSeverity(result)} sx={{ mb: 3 }}>
      <AlertTitle>{getTitle()}</AlertTitle>
      {result.connectionError && (
        <Typography variant='body2'>{getErrorMessage()}</Typography>
      )}
      {result.folders.map((folder) => (
        <Typography variant='body2' key={folder.path}>
          {getFolderLabel(folder)}: {folder.path}
        </Typography>
      ))}
    </Alert>
  );
};

export default SftpConnectionTestResult;
